export const GET_SYSTEM_ADMIN_CERTIFICATE = 'getSystemAdminCertificate';
export const UPDATE_SYSTEM_ADMIN_CERTIFICATE = 'updateSystemAdminCertificate';
export const ADD_SYSTEM_ADMIN_CERTIFICATES = 'addSystemAdminCertificates';
export const ADD_SYSTEM_ADMIN_CERTIFICATE = 'addSystemAdminCertificate';
export const DELETE_SYSTEM_ADMIN_CERTIFICATE = 'deleteSystemAdminCertificate';
